export const SUBPUSH_PAGES = [
  "/nutrafol-core-for-women/3-month/",
  "/women-balance/3-month/",
  "/womens-vegan/3-month/",
  "/nutrafol-postpartum-for-women/3-month/",
  "/men/products/thinning-hair-growth-supplement/3-month/",
]

export const ACCOUNT_PAGES = [
  "/customer/account/create/",
  "/customer/account/login/",
  "/customer/account/forgotpassword/",
  "/customer/account/code/",
  "/customer/account/password/",
  "/customer/account/password/forgot/",
]

export const NO_RIBBONLINK_PAGES = [
  "/products/",
  "/nutrafol-core-for-women/",
  "/womens-vegan/",
  "/women-balance/",
  "/nutrafol-postpartum-for-women/",
  "/de-stress-hair-growth-duo/",
  "/gut-microbiome-hair-growth-duo/",
  "/strengthening-hair-growth-duo/",
  "/hormone-support-hair-growth-duo/",
  "/toxin-cleanse-hair-growth-duo/",
  "/energy-hair-growth-duo/",
  "/products/hair-kit/",
  "/bundledhairgrowth/search/",
]

export const TT_PAGES = ["/tt/promo/"]

export const RIBBON_MAP = {
  subpush: {
    copy: "Put your hair growth plan on autopilot with a Nutrafol subscription <br class='block md:hidden'/> and  <span class='font-dinamoBold'>see results in as little as 3 months.</span>",
    href: null,
  },
  pick_your_booster: {
    copy: "{name}, celebrate with a free booster. <span class='font-dinamoBold'>Pick yours!</span>",
    href: "/account/rewards/?traffic_source=pencil_banner",
  },
  pay_it_forward: {
    copy: "{name}, keep growing with $5 off. <span class='font-dinamoBold'>Apply now!</span>",
    href: "/account/rewards/?traffic_source=pencil_banner",
  },
  upgrade_booster: {
    copy: "{name}, save 5% on renewals. <span class='font-dinamoBold'>Add your booster!</span>",
    href: "/account/rewards/?traffic_source=pencil_banner",
  },
  free_gift: {
    copy: "{name}, celebrate with a gift. <span class='font-dinamoBold'>Pick yours now!</span>",
    href: "/account/rewards/?traffic_source=pencil_banner",
  },
  refer_a_friend: {
    copy: "{name}, <i>refer friends and save!</i>",
    href: "/account/rewards/?traffic_source=pencil_banner",
  },
  ribbon_products: {
    copy: "Shop All Products",
    href: "/products/",
  },
  ribbon_products_men: {
    copy: "Shop All Products",
    href: "/men/products/",
  },
  serum: {
    copy: "Nutrafol Men + Hair Serum for visible results in as little as 3 months.",
    href: "/men/products/thinning-hair-supplements-and-serum/",
  },
}

export const CAPTCHA_PAGES = [
  "login",
  "create",
  "password",
  "profile",
  "subscriptions",
  "edit-address",
  "edit",
  "privacy-policy",
  "privacy-request",
]

export const MAY_GIFTING_CART_DATA = [
  {
    codes: ["WOMGIFT", "WOMCHRNGIFT"],
    sku: "WOMGWP",
    image:
      "https://images.ctfassets.net/0rbfqd9c4jdo/13Bd77Aiysign2P5x34x2L/7f00549f942278e3af603be662fcaa3a/women-cart-may-gwp-gift.jpeg",
  },
  {
    codes: ["BALGIFT", "BALCHRNGIFT"],
    sku: "BALGWP",
    image:
      "https://images.ctfassets.net/0rbfqd9c4jdo/8IIxp0zj6AxzoTj9F3sr8/27f43c805537dbc457d7ca9d5317913f/balance-cart-may-gwp-gift.jpeg",
  },
  {
    codes: ["VEGGIFT", "VEGCHRNGIFT"],
    sku: "VEGGWP",
    image:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1A6rd6whnvKvu0XmtTU1ik/43c93f69f6b961dfdae3bac9fed7fa2e/vegan-cart-may-gwp-gift.jpeg",
  },
  {
    codes: ["POSGIFT", "POSCHRNGIFT"],
    sku: "POSGWP",
    image:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1r3J5F6qbLw0raiDmwfnyM/59f42fe36e9b77ca805ac75930954f0c/postpartum-cart-may-gwp-gift.jpeg",
  },
  {
    codes: ["MENGIFT", "MENCHRNGIFT"],
    sku: "MENGWP",
    image:
      "https://images.ctfassets.net/0rbfqd9c4jdo/23CiYhi0jhjXiXyGEBI5YP/e03706e48a58f86b76039203895b5282/men-cart-may-gwp-gift.jpeg",
  },
]

/*
 * this code should be in sync with PROMOSKU fro cart removal logic
 *  NT2-23550 Cart | UNDO does not work as expected when promo code + purchase_source are used
 */
export const CAREKITCODE = "ACTFNF"
export const CAREKIT2CODE = "JULYSCALPGWP"
export const CAREKIT2CODEMEN = "JULYMSCALPGWP"

export const HIDE_REVERSEARROW_LINK = [
  "/promo/julyrestart3/",
  "/scalp/promo/july2for80/",
  "/promo/julyrestart-travelkit/",
  "/scalp/promo/augustbundle-travelkit/",
  "/scalp/promo/augustbundle/",
  "/promo/augustrestartgwp/",
  "/promo/augustrestart-travelkit/",
]
